import { useEffect, useRef } from 'react'

export const useUpdate = value => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return [ref.current, value]
}
